import { Loadable } from '@/components/loaders';
import RouteConstants from '@/features/router/RouteConstants';
import { useWorkspace } from '@/features/workspaces/hooks';
import { PageLayout, PageListHeader } from '@/global/components';
import { IconButton } from '@/lib';
import { BreadcrumbItem } from '@/lib/Breadcrumbs';
import { useGetDistributionChannelConnectorsQuery } from '@/services/endpoints/distributionChannels';
import { useGetWorkspaceConnectorsQuery } from '@/services/endpoints/workspace-connectors';
import TargetIcon from '@assets/icons/target.svg?react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { DataCatalogDestinationGrid } from './DataCatalogDestinationGrid';

const breadcrumbs: BreadcrumbItem[] = [
  {
    label: 'ALL:destinations.title',
    path: RouteConstants.destinations,
  },
];

export const CatalogDestinationContent: FC = () => {
  const { id: workspaceId } = useWorkspace();
  const { data: legacyConnectors, isLoading: legacyLoading } = useGetDistributionChannelConnectorsQuery({ workspaceId });
  const { data: customConnectors, isLoading: customLoading } = useGetWorkspaceConnectorsQuery({ workspaceId });

  const { t } = useTranslation();
  const history = useHistory();

  const isLoading = legacyLoading || customLoading;
  const hasCustomConnectors = customConnectors && customConnectors.length > 0;

  return (
    <PageLayout>
      <PageListHeader breadcrumbs={breadcrumbs} title='ALL:destinations.catalogDestinations' subtitle='ALL:destinations.catalogDestinationsSubtitle'>
        <div className='flex gap-3'>
          <IconButton
            leadingIcon={<TargetIcon className='size-6 text-white-100' />}
            className='inline-flex w-full max-w-[211px] justify-center'
            onClick={() => history.push(RouteConstants.createDestination)}
            text={t('ALL:destinations.audienceConnectAction')}
          />
          {hasCustomConnectors && (
            <IconButton
              leadingIcon={<TargetIcon className='size-6 text-white-100' />}
              className='inline-flex w-full justify-center'
              onClick={() => history.push(RouteConstants.createCustomDestination)}
              text={t('ALL:destinations.audienceConnectActionCustom')}
            />
          )}
        </div>
      </PageListHeader>

      <Loadable isLoading={isLoading}>
        <DataCatalogDestinationGrid dataDestinations={legacyConnectors} customConnectors={customConnectors} />
      </Loadable>
    </PageLayout>
  );
};
